/* Project Import will be here */
import {UPDATE_FOLDER} from '../action/action';

let defaultState = {
    folderList: []
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case UPDATE_FOLDER:
            return {
                ...state,
                folderList: action.folderList,
            };
        default:
            return state || defaultState;
    }
}



